import React, { useState, useEffect, useContext } from 'react';

import * as net from "../../../lib/net";

import Ff_Input from "../../../lib/ui/ff_input";
import PdfRpDlg from "../fkn/pdf_rp_dlg";
//import Caspeco_Logg from "./caspeco_logg";

class Caspeco_Wnd extends React.Component {
  constructor(props, context) {
    super(props);

    this.store = props.store;
    this.state = {};
    this.state.cols = {};

    this.state.ix = 0;
    this.state.plu = "";
    this.state.text = "";
    this.state.pris = "";
    this.state.wnds = {};

    this.state.cfg = {};
    this.state.cfg.tso = {};
    this.state.cfg.tso.dbi = {};
    this.state.cfg.cdo = {};
    
    this.state.tra = [];
    if(props.wnds) {
        this.state.tra = Object.values(this.state.dto.nts);
    }

    this.state.pdf = 0;
    this.state.pdf_content = null;
    //alert('BRA: ' + JSON.stringify(this.state.bra));
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
    this.caspeco_info();
  }

    dlg_style() {
      var css = {};
      //css.width = window.innerWidth * 0.8;
      //css.height = window.innerHeight * 0.8;
      return css;
    }
  tb_style() {
      var css = {};
      css.height = (window.innerHeight * 0.9) - 150;
      css.overflow = "auto";
      return css;
  }

    wnd_close = () => {
		this.props.ctx.setState({ wnds: {} });
		this.props.ctx.setState({ rptyp: "" });
	};

  pdf_done (ret) {
    this.setState({loading: 0, pdf: 0, pdf_content: null });
  }

  caspeco_info() {
          var self = this;
  
          var prm = {};
          prm.req = "sys.cfg.cfg";
          prm.avd = this.state.avd;
  
          net.sio_req(prm)
          .then(function(ret){
              //alert(JSON.stringify(ret.cfg));
  
              var cfg = ret.cfg;
              if(cfg == "") return;
              //alert( Object.keys(syo.if.fortnox) );
              self.setState({ cfg: cfg });
          })
          .catch(function(e){
              var txt = JSON.stringify(e);
          });
      }
  

    caspeco_logg() {
      var self = this;
      var wnds = {};
      wnds.caspecologg = true;
      self.setState({ wnds: wnds });
    }

render() {

	var html =
        <div className="mx_base">
        { this.props.backdrop ? <div className="mx_backdrop" /> : null }
        <div className="mx_dlg mx_90 flex-col" style={ this.dlg_style() }>

        <div className="mx_content flex">
            <div className="flex-row" style={{padding:"5px",height:"30px"}}>
                    <div className="flex-row txt_18">
                        <div>CASPECO</div>
                    </div>
                    <div className="flex-row flex txt_18">
                    </div>
            </div>
            <div className="divider_orange"></div>

            <div className="flex-row">
              <div className="flex"></div>
              <div className="web-link txt_16 px-2" onClick={() => this.caspeco_info() }>Uppdatera</div>
            </div>

            <div className="divider_orange"></div>

            <div className="flex-col flex-cc flex">

            <div className="flex-col">
            <div className="flex-row">
            <div className="cdi_val_box w350">
                <label>Sid</label>
                <input type="text" placeholder="" value={ this.state.cfg.sid } style={{ "border":"0px solid #000" }} onChange={(event) => this.handleUserInput(event)} required />
            </div>
            <div className="cdi_val_box w450">
                <label>Text</label>
                <input type="text" placeholder="" value={ this.state.cfg.text } style={{ "border":"0px solid #000" }} onChange={(event) => this.handleUserInput(event)} required />
            </div>
            </div>

            <div className="flex-row">
            <div className="cdi_val_box w350">
                <label>Registrerad</label>
                <input type="text" placeholder="" value={ this.state.cfg.tso.dbi.sqlhost } style={{ "border":"0px solid #000" }} onChange={(event) => this.handleUserInput(event)} required />
            </div>
            <div className="cdi_val_box w450">
            </div>
            </div>

            <div className="flex-row">
            <div className="cdi_val_box w350">
                <label>Access Valid</label>
                <input type="text" placeholder="" value={ this.state.cfg.tso.dbi.sqlport } style={{ "border":"0px solid #000" }} onChange={(event) => this.handleUserInput(event)} required />
            </div>
            <div className="cdi_val_box w450">
                <label>Access Token</label>
                <input type="text" placeholder="" value={ this.state.cfg.tso.dbi.sqldb } style={{ "border":"0px solid #000" }} onChange={(event) => this.handleUserInput(event)} required />
            </div>
            </div>

            <div className="flex-row">
            <div className="cdi_val_box w350">
                <label>Refresh Valid</label>
                <input type="text" placeholder="" value={ this.state.cfg.cdo.unittext } style={{ "border":"0px solid #000" }} onChange={(event) => this.handleUserInput(event)} required />
            </div>
            <div className="cdi_val_box w450">
                <label>Refresh Token</label>
                <input type="text" placeholder="" value={ this.state.cfg.cdo.unitid } style={{ "border":"0px solid #000" }} onChange={(event) => this.handleUserInput(event)} required />
            </div>
            </div>
            <div className="flex-row">
            <div className="cdi_val_box w350">
                <label>Token</label>
                <input type="text" placeholder="" value={ this.state.cfg.cdo.guid } style={{ "border":"0px solid #000" }} onChange={(event) => this.handleUserInput(event)} required />
            </div>
            <div className="cdi_val_box w450">
                <label>Refresh Token</label>
                <input type="text" placeholder="" value={ this.state.cfg.cdo.pre } style={{ "border":"0px solid #000" }} onChange={(event) => this.handleUserInput(event)} required />
            </div>
            </div>

            </div>
            </div>

        </div>

        <div className="divider_blue"></div>
        <div className="flex-row">
            <div className="web-link txt_16 px-2" onClick={() => this.caspeco_reg() }>Registrera Caspeco</div>
            <div className="flex"></div>
            <div className="web-link txt_16 px-2" onClick={() => this.caspeco_auto() }>Caspeco Överför</div>
        </div>

        <div className="mx_foot flex-row flex-space-between">
            <button className="btn btn-hw-red w250" onClick={() => this.wnd_close() } >
                STÄNG
            </button>
            <div className="flex"></div>
            <div className="flex"></div>
            <button className="btn btn-hw-green w250" onClick={(event) => this.prn_copy(event) } >
                SKRIV UT
            </button>
            
        </div>
      </div>

      <PdfRpDlg show={this.state.pdf} pdf={this.state.pdf_content} done={(ret) => this.pdf_done(ret)} backdrop={true}/>
      </div>
	;
	return html;
  };
}

export default Caspeco_Wnd;

/*
            <button className="btn btn-hw-blue w250" onClick={(event) => this.fx_logg(event) } >
                LOGG
            </button>

      { this.state.wnds.caspecologg ? <Caspeco_Logg wnds={this.state.wnds} ctx={this} store={this.props.store} backdrop={true}/> : null }

*/